import React from 'react';
import { useBrokerDetailsStore } from '../../../../state/brokerDetailsStore';
import { CheckButton } from '@apply/components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFlag } from '@fortawesome/free-solid-svg-icons';
import { isMobileScreen } from '@apply/ui';

export const BrokerFlaggedField: React.FC = () => {
    const mobileScreen = isMobileScreen();
    const brokerFlagged = useBrokerDetailsStore((s) => s.brokerFlagged);
    const updateFields = useBrokerDetailsStore((s) => s.updateFields);

    return (
        <>
            <CheckButton
                id='brokerFlagged'
                selected={brokerFlagged}
                onToggle={() => updateFields({ brokerFlagged: !brokerFlagged })}
                label='Broker is Flagged'
                width={!mobileScreen ? '200px' : '100%'}
            />
            {brokerFlagged && (
                <>
                    &nbsp;
                    <FontAwesomeIcon
                        style={{ color: 'darkred' }}
                        icon={faFlag}
                    />
                </>
            )}
        </>
    );
};
